import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'signet-avatar',
  styleUrl: 'signet-avatar.scss',
  shadow: true,
})
export class Avatar {
  @Element() elm!: HTMLElement;

  /**
   *  Specifies the size of the avatar.
   */
  @Prop() size = '2rem';
  /**
   *  Specifies the name to display in the avatar. Defaults to an empty string.
   */
  @Prop() name = '';
  /**
   *  Specifies the URL of the image to display in the avatar. Defaults to an empty string.
   */
  @Prop() image = '';

  private getInitials() {
    const name = this.name.split(' ');
    const firstName = name[0] ? name[0].charAt(0).toUpperCase() : '';
    const lastName = name[1] ? name[1].charAt(0).toUpperCase() : '';
    return `${firstName}${lastName}`;
  }

  private getFontSize() {
    const size = this.size;
    const match = size.match(/^\d+(\.\d{1,2})?/);
    const fontSize = match ? Number(match[0]) : 0;
    return (fontSize * 4) / 10 + size.replace(/^\d+(\.\d{1,2})?/, '');
  }

  render() {
    const cssCls = ['avatar'];
    if (this.image) {
      cssCls.push('avatar-image');
    } else {
      cssCls.push('avatar-initials');
    }
    return (
      <Host title={this.name}>
        <div class="avatar-container">
          <div
            class={cssCls.join(' ')}
            style={{
              width: this.size,
              height: this.size,
              fontSize: this.getFontSize(),
            }}
          >
            {(() => {
              if (this.image) {
                return <img class="image" src={this.image} alt={this.name} />;
              } else {
                return <div class="initials">{this.getInitials()}</div>;
              }
            })()}
          </div>
        </div>
      </Host>
    );
  }
}
